/* Carrito lateral (Carlos 2026-09-18). Lee /cart.js, cambia con /cart/change.js y sugiere con
   /recommendations/products.json productos cuyo precio se acerca a lo que falta para envío gratis.
   Al cambiar el carrito reescribe .cart-counter: assets/sd-shipping-progress.js observa ese contador
   y agrega o quita el regalo; por eso se vuelve a leer el carrito un momento después.
   API pública: window.sdCarrito.abrir(), .agregado() */
(() => {
  const panel = document.getElementById('sd-carrito-lateral');
  if (!panel) return;
  const root = window.Shopify?.routes?.root || '/';
  const MIN = +panel.dataset.minimo, GRATIS = +panel.dataset.gratis, ENVIO = +panel.dataset.envio, REGALO = +panel.dataset.regalo;
  const $ = (s) => panel.querySelector(s);
  const velo = document.querySelector('[data-sdc-velo]');
  const aviso = document.querySelector('[data-sdc-aviso]');
  const cuerpo = $('[data-sdc-cuerpo]'), pie = $('[data-sdc-pie]'), pagar = $('[data-sdc-pagar]');
  const pesos = (c) => '$' + Math.round(c / 100).toLocaleString('es-MX');
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const img = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';
  let carro = null, ocupado = false, ultimoFoco = null, sugeridos = [], sugDe = null;

  const pide = async (ruta, cuerpoJson) => {
    const r = await fetch(root + ruta, cuerpoJson ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpoJson) } : { headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'No pudimos actualizar el carrito. Intenta de nuevo.');
    return j;
  };
  const avisaContador = (c) => {
    document.querySelectorAll('.cart-counter').forEach((n) => { n.textContent = c.item_count; });
    document.querySelectorAll('.depot-cart-link').forEach((a) => a.setAttribute('aria-label', `Ver carrito, ${c.item_count} productos`));
  };

  async function sugerencias(items, falta) {
    const base = items.find((i) => i.variant_id !== REGALO);
    if (!base) return [];
    if (sugDe !== base.product_id) {
      sugDe = base.product_id;
      try { sugeridos = (await pide(`recommendations/products.json?product_id=${base.product_id}&limit=10&intent=related`)).products || []; } catch (_) { sugeridos = []; }
    }
    const enCarro = new Set(items.map((i) => i.product_id));
    // Carlos 30 sep: nunca sugerir chocolates, son lo que llega derretido (Eloisa #1013, Lindor 240 g).
    const derrite = (p) => /chocolat|lindor|lindt|reese|m&m|kit ?kat|twix|hershey|snickers|milky ?way|musketeers|butterfinger|ferrero|toblerone|kinder|ghirardelli|truffle|trufa|fudge|cacao|cocoa/i.test(`${p.title} ${p.type || ''} ${(p.tags || []).join(' ')}`);
    return sugeridos.filter((p) => p.available && !enCarro.has(p.id) && p.variants?.[0]?.available && !derrite(p))
      .sort((a, b) => Math.abs(a.price - falta) - Math.abs(b.price - falta)).slice(0, 3);
  }

  // Carlos 28 sep: una clienta no podía quitar productos; el redibujo reemplazaba el botón bajo su dedo.
  let pintado = '';
  const firma = (c) => JSON.stringify([c.items.map((i) => i.key + ':' + i.quantity), c.total_price, (c.discount_codes || []).map((d) => d.code + d.applicable)]);
  async function pinta() {
    const c = carro;
    pintado = firma(c);
    const items = c.items;
    const productos = items.filter((i) => i.variant_id !== REGALO);
    const sub = c.total_price; // ya con descuentos: Shopify evalúa mínimo y envío gratis sobre este total
    const desc = c.total_discount || 0;
    $('[data-sdc-n]').textContent = c.item_count ? `(${c.item_count})` : '';
    if (!productos.length) {
      cuerpo.innerHTML = `<div class="sdc-avance">Tu carrito está vacío. <b>Envío gratis y snack de regalo desde $1,500.</b></div><p class="sdc-vacio" style="margin-top:16px"><a href="${root}collections/seleccion-del-depot" style="color:#C18E5F">Ver lo más pedido ↗</a></p>`;
      pie.hidden = true; return;
    }
    const pc = Math.min(100, sub / GRATIS * 100);
    let avance;
    if (sub < MIN) avance = `<div class="sdc-avance">Pedido mínimo $499: <b>te faltan ${pesos(MIN - sub)}</b><div class="sdc-barra"><i style="width:${pc}%"></i></div></div>`;
    else if (sub < GRATIS) avance = `<div class="sdc-avance"><b>Te faltan ${pesos(GRATIS - sub)}</b> para envío gratis y un snack de edición limitada de regalo<div class="sdc-barra"><i style="width:${pc}%"></i></div></div>`;
    else avance = `<div class="sdc-avance is-ok"><b>¡Listo!</b> Envío gratis y snack de regalo incluidos<div class="sdc-barra"><i style="width:100%"></i></div></div>`;
    const lineas = items.map((i) => i.variant_id === REGALO
      ? `<div class="sdc-linea sdc-regalo"><div class="sdc-ph" aria-hidden="true">🎁</div><div><div class="sdc-n"><b>Snack de edición limitada</b><br>Regalo, va en tu caja</div><div class="sdc-p">$0</div></div><span></span></div>`
      : `<div class="sdc-linea"><a class="sdc-ph" href="${i.url}">${i.image ? `<img src="${img(i.image, 160)}" alt="" loading="lazy">` : ''}</a><div><a class="sdc-n" href="${i.url}">${esc(i.product_title)}</a><div class="sdc-p">${pesos(i.final_line_price)}</div><button type="button" class="sdc-quitar" data-sdc-cambia="${i.key}" data-q="0" aria-label="Quitar ${esc(i.product_title)} del carrito">Quitar</button></div><div class="sdc-paso" role="group" aria-label="Cantidad de ${esc(i.product_title)}"><button type="button" data-sdc-cambia="${i.key}" data-q="${i.quantity - 1}" aria-label="Quitar uno">−</button><span>${i.quantity}</span><button type="button" data-sdc-cambia="${i.key}" data-q="${i.quantity + 1}" aria-label="Agregar uno">+</button></div></div>`).join('');
    cuerpo.innerHTML = avance + lineas;
    const falta = GRATIS - sub;
    if (falta > 0) {
      const s = await sugerencias(items, falta);
      if (s.length && carro === c) cuerpo.insertAdjacentHTML('beforeend', `<div class="sdc-sug"><h3>Completa tu envío gratis</h3>${s.map((p) => `<div class="sdc-sug-fila"><a class="sdc-ph" href="${p.url}">${p.featured_image ? `<img src="${img(p.featured_image, 120)}" alt="" loading="lazy">` : ''}</a><div><a class="sdc-n" href="${p.url}">${esc(p.title)}</a><div class="sdc-p">${pesos(p.price)}</div></div><button type="button" class="sdc-agregar" data-sdc-agrega="${p.variants[0].id}">Agregar</button></div>`).join('')}</div>`);
    }
    const envio = sub >= GRATIS ? 0 : ENVIO;
    $('[data-sdc-sub]').textContent = pesos(sub + desc);
    $('[data-sdc-desc-fila]').hidden = !desc; $('[data-sdc-desc]').textContent = '-' + pesos(desc);
    const cs = (c.discount_codes || []), cz = $('[data-sdc-cupones]');
    cz.hidden = !cs.length;
    cz.innerHTML = cs.map((d) => `<span class="sdc-cupon-chip ${d.applicable ? '' : 'is-no'}">${esc(d.code)} ${d.applicable ? 'aplicado' : 'no aplica a este carrito'} <button type="button" data-sdc-quita-cupon aria-label="Quitar código ${esc(d.code)}">×</button></span>`).join('');
    $('[data-sdc-envio]').textContent = envio ? pesos(envio) : 'Gratis';
    $('[data-sdc-total]').textContent = pesos(sub + envio);
    const bloqueo = $('[data-sdc-bloqueo]');
    bloqueo.hidden = sub >= MIN;
    bloqueo.textContent = sub < MIN ? `Agrega ${pesos(MIN - sub)} más para poder pagar (pedido mínimo $499).` : '';
    pagar.setAttribute('aria-disabled', String(sub < MIN));
    // Auditoría 2026-09-22: abajo del mínimo el botón decía "Pagar $289" en gris y al tocarlo no
    // pasaba absolutamente nada (medido: sin navegación y sin ningún cambio en pantalla). Ahora el
    // botón dice qué falta, en vez de prometer un pago que no va a ocurrir.
    pagar.querySelector('span').textContent = sub < MIN ? `Te faltan ${pesos(MIN - sub)} para pagar` : `Pagar ${pesos(sub + envio)}`;
    pie.hidden = false;
  }

  async function lee() { carro = await pide('cart.js'); return carro; }
  async function refresca() { try { await lee(); if (firma(carro) !== pintado) await pinta(); } catch (e) { cuerpo.innerHTML = `<p class="sdc-vacio">${esc(e.message)}</p>`; } }

  async function cambia(ruta, datos) {
    if (ocupado) return; ocupado = true; panel.setAttribute('aria-busy', 'true');
    try { await pide(ruta, datos); await lee(); avisaContador(carro); await pinta(); setTimeout(() => { if (panel.classList.contains('is-on')) refresca(); }, 1200); }
    catch (e) { muestraAviso(e.message); }
    finally { ocupado = false; panel.removeAttribute('aria-busy'); }
  }

  function abrir() {
    ultimoFoco = document.activeElement;
    velo.hidden = false; requestAnimationFrame(() => velo.classList.add('is-on'));
    panel.classList.add('is-on'); panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sdc-abierto');
    ocultaAviso();
    $('.sdc-cerrar').focus({ preventScroll: true });
    refresca();
  }
  function cerrar() {
    panel.classList.remove('is-on'); panel.setAttribute('aria-hidden', 'true');
    velo.classList.remove('is-on'); setTimeout(() => { velo.hidden = true; }, 200);
    document.documentElement.classList.remove('sdc-abierto');
    ultimoFoco?.focus?.({ preventScroll: true });
  }
  let tAviso;
  function ocultaAviso() {
    aviso.hidden = true; aviso.classList.remove('is-agregado');
    document.documentElement.classList.remove('sdc-aviso-on');
  }
  function muestraAviso(html) {
    ocultaAviso();
    aviso.innerHTML = `<span>${html}</span>`;
    aviso.hidden = false; clearTimeout(tAviso); tAviso = setTimeout(ocultaAviso, 3200);
  }
  // 3 oct (auditoría aprobada por Carlos, E3/E4): tras agregar, UN solo aviso con "Seguir comprando" y
  // "Pagar $X" (mismo total que el carrito: subtotal con descuentos + envío). Se queda hasta que la persona
  // toque algo; mientras está, la barra de envío se esconde (no repetir "Te faltan") y WhatsApp sube.
  async function agregado() {
    try {
      const c = await lee();
      if (panel.classList.contains('is-on')) { await pinta(); return; }
      const sub = c.total_price, envio = sub >= GRATIS ? 0 : ENVIO;
      clearTimeout(tAviso);
      aviso.innerHTML = `<p class="sdc-aviso-t">✓ Agregado. ${sub >= GRATIS ? '<b>Ya tienes envío gratis y regalo.</b>' : `Te faltan <b>${pesos(GRATIS - sub)}</b> para envío gratis.`}</p><div class="sdc-aviso-b"><button type="button" data-sdc-seguir>Seguir comprando</button><a href="${root}checkout" data-sdc-ir>Pagar ${pesos(sub + envio)}</a></div>`;
      aviso.classList.add('is-agregado'); aviso.hidden = false;
      document.documentElement.classList.add('sdc-aviso-on');
      document.documentElement.style.setProperty('--sdc-aviso-alto', aviso.offsetHeight + 'px');
    } catch (_) { /* el agregado ya pasó; el aviso es opcional */ }
  }
  document.addEventListener('pointerdown', (e) => { if (aviso.classList.contains('is-agregado') && !aviso.contains(e.target)) ocultaAviso(); }, { passive: true });

  cuerpo.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sdc-cambia]');
    if (b) {
      // Carlos 29 sep: que se sienta al instante. Numero nuevo y linea atenuada antes de que responda Shopify.
      const n = Math.max(0, +b.dataset.q), linea = b.closest('.sdc-linea'), num = linea?.querySelector('.sdc-paso span');
      if (linea) { linea.classList.add('is-cargando'); if (n === 0) linea.classList.add('is-saliendo'); }
      if (num && n > 0) num.textContent = n;
      cambia('cart/change.js', { id: b.dataset.sdcCambia, quantity: n }).finally(() => linea?.classList.remove('is-cargando'));
      return;
    }
    const a = e.target.closest('[data-sdc-agrega]');
    if (a) { a.disabled = true; a.textContent = 'Agregando…'; cambia('cart/add.js', { items: [{ id: +a.dataset.sdcAgrega, quantity: 1 }] }); }
  });
  $('[data-sdc-cerrar]').addEventListener('click', cerrar);
  velo.addEventListener('click', cerrar);
  // Cupón en el carrito: queda guardado en el carrito y Apple Pay, PayPal y Shop Pay ya lo llevan aplicado
  $('[data-sdc-cupon]').addEventListener('submit', async (e) => {
    e.preventDefault();
    const inp = e.currentTarget.codigo, code = inp.value.trim().toUpperCase();
    if (!code) { inp.focus(); return; }
    const antes = new Set((carro?.discount_codes || []).map((d) => d.code));
    const todos = [...antes, code].join(',');
    await cambia('cart/update.js', { discount: todos });
    const d = (carro?.discount_codes || []).find((x) => x.code.toUpperCase() === code);
    muestraAviso(d && d.applicable ? `Código ${esc(code)} aplicado` : `El código ${esc(code)} no existe o no aplica a este carrito`);
    inp.value = '';
  });
  $('[data-sdc-cupones]').addEventListener('click', async (e) => {
    const b = e.target.closest('[data-sdc-quita-cupon]'); if (!b) return;
    const quita = b.getAttribute('aria-label').replace('Quitar código ', '');
    const resto = (carro?.discount_codes || []).map((d) => d.code).filter((c) => c !== quita).join(',');
    await cambia('cart/update.js', { discount: resto });
  });
  aviso.addEventListener('click', (e) => { if (e.target.closest('[data-sdc-seguir]')) ocultaAviso(); });
  document.addEventListener('keydown', (e) => { if (e.key !== 'Escape') return; if (panel.classList.contains('is-on')) cerrar(); else ocultaAviso(); });
  // Todo enlace al carrito abre el panel, salvo en la página del carrito (ahí se queda la versión completa).
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || panel.contains(a) || e.metaKey || e.ctrlKey || e.shiftKey) return;
    let url; try { url = new URL(a.href, location.href); } catch (_) { return; }
    const enCarro = location.pathname.replace(root, '/').startsWith('/cart');
    if (!enCarro && url.origin === location.origin && url.pathname.replace(root, '/') === '/cart') { e.preventDefault(); abrir(); }
  });
  // Total en el encabezado y avance de "Arma tu caja": se recalculan cada vez que cambia el contador.
  function encabezado(c) {
    const sub = c.items.filter((i) => i.variant_id !== REGALO).reduce((s, i) => s + i.final_line_price, 0);
    document.querySelectorAll('.cart-total').forEach((n) => { n.textContent = c.item_count ? pesos(sub) : ''; });
    const f = document.querySelector('[data-sd-caja-fill]'), tx = document.querySelector('[data-sd-caja-tx]');
    if (f) f.style.width = Math.min(100, sub / GRATIS * 100) + '%';
    if (tx) tx.textContent = sub >= GRATIS ? '¡Listo! Ya tienes envío gratis' : sub > 0 ? `Llevas ${pesos(sub)} de $1,500` : 'Empieza con lo que se te antoje';
  }
  let tEnc;
  document.querySelectorAll('.cart-counter').forEach((n) => new MutationObserver(() => { clearTimeout(tEnc); tEnc = setTimeout(async () => { try { encabezado(await pide('cart.js')); } catch (_) {} }, 250); }).observe(n, { childList: true, characterData: true, subtree: true }));
  // "Combina con" en la ficha: 4 productos relacionados con "+" que agrega sin salir.
  const combina = document.querySelector('[data-sd-combina]');
  if (combina) (async () => {
    try {
      const ps = ((await pide(`recommendations/products.json?product_id=${combina.dataset.sdCombina}&limit=8&intent=related`)).products || []).filter((p) => p.available && p.variants?.[0]?.available && p.price > 0).slice(0, 4);
      if (!ps.length) return;
      combina.innerHTML = `<h3>Combina con</h3><div class="sd-combina__fila">${ps.map((p) => `<div class="sd-combina__it"><a href="${p.url}" class="sd-combina__ph">${p.featured_image ? `<img src="${img(p.featured_image, 240)}" alt="" loading="lazy">` : ''}</a><a href="${p.url}" class="sd-combina__n">${esc(p.title.split(' · ')[0])}</a><div class="sd-combina__pie"><b>${pesos(p.price)}</b><button type="button" class="sd-combina__mas" data-v="${p.variants[0].id}" aria-label="Agregar ${esc(p.title.split(' · ')[0])}">+</button></div></div>`).join('')}</div>`;
      combina.hidden = false;
      combina.addEventListener('click', async (e) => {
        const b = e.target.closest('.sd-combina__mas'); if (!b || b.disabled) return;
        b.disabled = true; b.textContent = '…';
        try { await pide('cart/add.js', { items: [{ id: +b.dataset.v, quantity: 1 }] }); avisaContador(await lee()); b.textContent = '✓'; b.classList.add('is-ok'); agregado(); }
        catch (err) { b.textContent = '+'; b.disabled = false; muestraAviso(esc(err.message)); }
      });
    } catch (_) { /* sin recomendaciones no se muestra nada */ }
  })();
  window.sdCarrito = { abrir, cerrar, agregado };
})();
